/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var SketchfabWrapper={api:null,nodeMap:[],sceneGraph:null,textureList:[],getNodeMap:function getNodeMap(){this.api.getNodeMap(function(err,nodes){SketchfabWrapper.nodeMap=nodes;});},//get the scenegraph from the scene and add the parents to each node
getSceneGraph:function getSceneGraph(){this.api.getSceneGraph(function(err,graph){SketchfabWrapper.sceneGraph=graph;SketchfabWrapper.addSceneGraphFoodchain(SketchfabWrapper.sceneGraph,null);});},setAnimation:function setAnimation(idx){this.api.getAnimations(function(err,animations){SketchfabWrapper.setAnimationCallback(animations,idx);});},setAnimationCallback:function setAnimationCallback(animations,idx){if(animations.length>idx){var animationUid=animations[idx][0];this.api.setCurrentAnimationByUID(animationUid,function(err){});}},//go over the scenegraph and add the parent to each node
addSceneGraphFoodchain:function addSceneGraphFoodchain(currentNode,parentNode){if(parentNode!==null){currentNode.parent=parentNode;};if(currentNode.hasOwnProperty('children')){currentNode.children.some(function(child){return SketchfabWrapper.addSceneGraphFoodchain(child,currentNode);});};},//get a node from the graph with a specific instanceID
getNodeFromGraphByID:function getNodeFromGraphByID(currentNode,instanceID){if(currentNode.instanceID===instanceID){return currentNode;}if(currentNode.hasOwnProperty('children')){var node;currentNode.children.some(function(child){return node=SketchfabWrapper.getNodeFromGraphByID(child,instanceID);});return node;}},//get a node from the graph with a specific name and type
getNodeFromGraphByName:function getNodeFromGraphByName(currentNode,theName,theType,theResult){if(currentNode.name===theName&&currentNode.type===theType){console.log('currentNode',currentNode);theResult.push(currentNode);}if(currentNode.hasOwnProperty('children')){currentNode.children.forEach(function(child){SketchfabWrapper.getNodeFromGraphByName(child,theName,theType,theResult);});}},getTextureList:function getTextureList(){this.api.getTextureList(function(err,textures){SketchfabWrapper.textureList=textures;});},filterNodeMapExactName:function filterNodeMapExactName(map,nodeName){var items=[];Object.keys(map).forEach(function(key,index){if(map[key].type=="MatrixTransform"&&map[key].name!=undefined&&map[key].name.toLowerCase()==nodeName.toLowerCase()){items.push(map[key]);}});return items;},//after a click event, sketchfab returns a modified objectname. this method
//iterates over the parent objects and tries to get the name from them
getNodeNameById:function getNodeNameById(instanceID,callback){var clickedNode=this.getNodeFromGraphByID(this.sceneGraph,instanceID);console.log('clickedNode',clickedNode);if(clickedNode!==undefined&&clickedNode.parent.type==='Group'){return clickedNode.parent.name;}},MakeTexture:function MakeTexture(uid){var texture={magFilter:"LINEAR",minFilter:"LINEAR_MIPMAP_LINEAR",wrapS:"REPEAT",wrapT:"REPEAT",textureTarget:"TEXTURE_2D",internalFormat:"RGB",texCoordUnit:0,uid:uid};return texture;},getNodeById:function getNodeById(instanceID,callback){var self=this;self.api.getNodeMap(function(err,nodes){if(!err){Object.keys(nodes).forEach(function(key,index){if(nodes[key].instanceID==instanceID){var node=nodes[key];callback(node);}});}});},filterNodeMapContainsName:function filterNodeMapContainsName(map,nodeName){var items=[];Object.keys(map).forEach(function(key,index){if(map[key].type=="MatrixTransform"&&map[key].name!=undefined&&map[key].name.toLowerCase().indexOf(nodeName.toLowerCase())==0){items.push(map[key]);}});return items;},SetObjectVisibility:function SetObjectVisibility(namePattern,doShow,matchNameExactly){var self=this;self.api.getNodeMap(function(err,nodes){if(err){console.log('Error getting nodes');return;}else{var matchedNodeArray=[];var patternArray=namePattern.split(',');//the objectnames may be supplied as a comma separated string
//first find the nodes
for(var n=0;n<patternArray.length;n++){var matches;if(matchNameExactly){matches=self.filterNodeMapExactName(nodes,namePattern);}else{matches=self.filterNodeMapContainsName(nodes,namePattern);}matchedNodeArray=matchedNodeArray.concat(matches);}//then hide or show them
for(var n=0;n<matchedNodeArray.length;n++){if(doShow){self.api.show(matchedNodeArray[n].instanceID);}else{self.api.hide(matchedNodeArray[n].instanceID);}}}});},GetView:function GetView(){// Print the current view as an view object we can send to sketchfab
this.api.getCameraLookAt(function(err,camera){console.log('View: {\n\teye: [%s,%s,%s],\n\tlookat: [%s,%s,%s]\n}',camera.position[0].toFixed(2),camera.position[1].toFixed(2),camera.position[2].toFixed(2),camera.target[0].toFixed(2),camera.target[1].toFixed(2),camera.target[2].toFixed(2));});},SetView:function SetView(eye,lookat,duration){//eye and lookat each are an array of three floats
this.api.lookat(eye,lookat,duration);}};exports.default=SketchfabWrapper;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(6);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _SketchfabWrapper=__webpack_require__(0);var _SketchfabWrapper2=_interopRequireDefault(_SketchfabWrapper);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Camera={loopTimeoutIndex:null,inPano:false,panoLookat:[0,0,0],//the position of the current pano
panoDistance:8,GetCameraAngle:function GetCameraAngle(camera){//get the up/down angle a camera is making
var targetPos=camera.target;var camPos=camera.position;var deltaZ=targetPos[2]-camPos[2];var zoomDistance=Camera.distanceVector(camPos,targetPos);var camAngle=Math.asin(deltaZ/zoomDistance);return camAngle;},EnforceMinCameraAngle:function EnforceMinCameraAngle(api){//enforce a minimum camera angle depending on the zoom distance and
//target height. formula by Carste Schonart
//minAngle = asin (orbitcentreheight/zoomdistance)
api.getCameraLookAt(function(err,camera){var targetPos=camera.target;var camPos=camera.position;var camPosOnGroundlevel=[camPos[0],camPos[1],0];var zoomDistance=Camera.distanceVector(camPosOnGroundlevel,targetPos);var minAngle=Math.asin(camera.target[2]/zoomDistance);// console.log('minAngle',minAngle);
var camAngle=Camera.GetCameraAngle(camera);// console.log('camAngle',camAngle);
//enforce the min angle
if(camAngle>minAngle){// var relativeCam = [targetPos[0]-camPos[0],targetPos[1]-camPos[1],targetPos[2]-camPos[2]];
var relativeCam=[camPos[0]-targetPos[0],camPos[1]-targetPos[1],camPos[2]-targetPos[2]];// console.log('relativeCam',relativeCam);
//calculate the angle in the xy plane
var gamma=Math.atan(relativeCam[0]/relativeCam[1]);if(relativeCam[1]<0){gamma=Math.PI+gamma;}if(relativeCam[1]>0&&relativeCam[0]<0){gamma=2*Math.PI+gamma;}// console.log('gamma',gamma);
// var gammaDeg = gamma * (180/Math.PI);
// console.log('gammaDeg',gammaDeg);
var S=Camera.distanceVector(camPos,targetPos);var Sxy=Math.sqrt(S*S-targetPos[2]*targetPos[2]);// var S = Math.sqrt(relativeCam[0]*relativeCam[0]+relativeCam[1]*relativeCam[1]+relativeCam[2]*relativeCam[2])
// console.log('S',S);
// console.log('Sxy',Sxy);
var x=Sxy*Math.sin(gamma);var Y=Sxy*Math.cos(gamma);// console.log('X',x);
// console.log('Y',Y);
var newPos=[x+targetPos[0],Y+targetPos[1],0];Camera.SetCamera(api,newPos,camera.target);};});},LockPano:function LockPano(distance){//locking a camera for a pano means
//locking the lookat
//locking the distance between eye and lookat
_SketchfabWrapper2.default.api.getCameraLookAt(function(err,camera){// console.log('camera',camera);
var camPos=camera.position;var targetPos=camera.target;var zoomDistance=Camera.distanceVector(camPos,targetPos);//enforce the maximum distance
if(zoomDistance!==Camera.panoDistance){//start at the target location and set the camera back to its maximum
//distance
var factor=Camera.panoDistance/zoomDistance;var newCamPos=[0,0,0];newCamPos[0]=Camera.panoLookat[0]+(camPos[0]-Camera.panoLookat[0])*factor;newCamPos[1]=Camera.panoLookat[1]+(camPos[1]-Camera.panoLookat[1])*factor;newCamPos[2]=Camera.panoLookat[2]+(camPos[2]-Camera.panoLookat[2])*factor;_SketchfabWrapper2.default.api.setCameraLookAt(newCamPos,Camera.panoLookat,0.01);}else{//if we're still within range, we just reset the target. This is effectively
//blocking panning
_SketchfabWrapper2.default.api.setCameraLookAt(camera.position,Camera.panoLookat,0.01);};});},SetCamera:function SetCamera(api,eye,target){_SketchfabWrapper2.default.api.setCameraLookAt(eye,target,0.01);},distanceVector:function distanceVector(v1,v2){var dx=v1[0]-v2[0];var dy=v1[1]-v2[1];var dz=v1[2]-v2[2];return Math.sqrt(dx*dx+dy*dy+dz*dz);},cameraLoopOrbit:function cameraLoopOrbit(){Camera.EnforceMinCameraAngle(_SketchfabWrapper2.default.api);Camera.loopTimeoutIndex=setInterval(function(){Camera.EnforceMinCameraAngle(_SketchfabWrapper2.default.api);},50);},cameraLoopPano:function cameraLoopPano(distance,lookat){Camera.LockPano(distance,lookat);Camera.loopTimeoutIndex=setInterval(function(){Camera.LockPano(distance,lookat);},50);}};exports.default=Camera;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
module.exports = __webpack_require__(14);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(5).enable();
  window.Promise = __webpack_require__(8);
}

// fetch() polyfill for making API calls.
__webpack_require__(9);

// classList polyfill, mainly for consistent toggle() implementation
__webpack_require__(10);

// array.find (used by toggleFullscreen polyfill)
__webpack_require__(11);

// toggleFullscreen
__webpack_require__(12);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(13);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(1);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(1);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20150312
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
if (!("classList" in document.createElement("_")) 
	|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
	  classListProp = "classList"
	, protoProp = "prototype"
	, elemCtrProto = view.Element[protoProp]
	, objCtr = Object
	, strTrim = String[protoProp].trim || function () {
		return this.replace(/^\s+|\s+$/g, "");
	}
	, arrIndexOf = Array[protoProp].indexOf || function (item) {
		var
			  i = 0
			, len = this.length
		;
		for (; i < len; i++) {
			if (i in this && this[i] === item) {
				return i;
			}
		}
		return -1;
	}
	// Vendors: please allow content code to instantiate DOMExceptions
	, DOMEx = function (type, message) {
		this.name = type;
		this.code = DOMException[type];
		this.message = message;
	}
	, checkTokenAndGetIndex = function (classList, token) {
		if (token === "") {
			throw new DOMEx(
				  "SYNTAX_ERR"
				, "An invalid or illegal string was specified"
			);
		}
		if (/\s/.test(token)) {
			throw new DOMEx(
				  "INVALID_CHARACTER_ERR"
				, "String contains an invalid character"
			);
		}
		return arrIndexOf.call(classList, token);
	}
	, ClassList = function (elem) {
		var
			  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
			, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
			, i = 0
			, len = classes.length
		;
		for (; i < len; i++) {
			this.push(classes[i]);
		}
		this._updateClassName = function () {
			elem.setAttribute("class", this.toString());
		};
	}
	, classListProto = ClassList[protoProp] = []
	, classListGetter = function () {
		return new ClassList(this);
	}
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
	return this[i] || null;
};
classListProto.contains = function (token) {
	token += "";
	return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
	;
	do {
		token = tokens[i] + "";
		if (checkTokenAndGetIndex(this, token) === -1) {
			this.push(token);
			updated = true;
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.remove = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
		, index
	;
	do {
		token = tokens[i] + "";
		index = checkTokenAndGetIndex(this, token);
		while (index !== -1) {
			this.splice(index, 1);
			updated = true;
			index = checkTokenAndGetIndex(this, token);
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.toggle = function (token, force) {
	token += "";

	var
		  result = this.contains(token)
		, method = result ?
			force !== true && "remove"
		:
			force !== false && "add"
	;

	if (method) {
		this[method](token);
	}

	if (force === true || force === false) {
		return force;
	} else {
		return !result;
	}
};
classListProto.toString = function () {
	return this.join(" ");
};

if (objCtr.defineProperty) {
	var classListPropDesc = {
		  get: classListGetter
		, enumerable: true
		, configurable: true
	};
	try {
		objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	} catch (ex) { // IE 8 doesn't support enumerable:true
		if (ex.number === -0x7FF5EC54) {
			classListPropDesc.enumerable = false;
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		}
	}
} else if (objCtr[protoProp].__defineGetter__) {
	elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(self));

} else {
// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
	"use strict";

	var testElement = document.createElement("_");

	testElement.classList.add("c1", "c2");

	// Polyfill for IE 10/11 and Firefox <26, where classList.add and
	// classList.remove exist but support only one argument at a time.
	if (!testElement.classList.contains("c2")) {
		var createMethod = function(method) {
			var original = DOMTokenList.prototype[method];

			DOMTokenList.prototype[method] = function(token) {
				var i, len = arguments.length;

				for (i = 0; i < len; i++) {
					token = arguments[i];
					original.call(this, token);
				}
			};
		};
		createMethod('add');
		createMethod('remove');
	}

	testElement.classList.toggle("c3", false);

	// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	// support the second argument.
	if (testElement.classList.contains("c3")) {
		var _toggle = DOMTokenList.prototype.toggle;

		DOMTokenList.prototype.toggle = function(token, force) {
			if (1 in arguments && !this.contains(token) === !force) {
				return force;
			} else {
				return _toggle.call(this, token);
			}
		};

	}

	testElement = null;
}());

}

}



/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Array.prototype.find = Array.prototype.find || function(callback) {
  if (this === null) {
    throw new TypeError('Array.prototype.find called on null or undefined');
  } else if (typeof callback !== 'function') {
    throw new TypeError('callback must be a function');
  }
  var list = Object(this);
  // Makes sures is always has an positive integer as length.
  var length = list.length >>> 0;
  var thisArg = arguments[1];
  for (var i = 0; i < length; i++) {
    var element = list[i];
    if ( callback.call(thisArg, element, i, list) ) {
      return element;
    }
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/*!
 * fullscreen-polyfill
 * 1.0.2 - 5/23/2018
 * https://github.com/nguyenj/fullscreen-polyfill#readme
 * (c) John Nguyen; MIT License
 */
var FullscreenPolyfill=function(){"use strict";var l=["fullscreen","fullscreenEnabled","fullscreenElement","fullscreenchange","fullscreenerror","exitFullscreen","requestFullscreen"],e=["webkitIsFullScreen","webkitFullscreenEnabled","webkitFullscreenElement","webkitfullscreenchange","webkitfullscreenerror","webkitExitFullscreen","webkitRequestFullscreen"],n=["mozFullScreen","mozFullScreenEnabled","mozFullScreenElement","mozfullscreenchange","mozfullscreenerror","mozCancelFullScreen","mozRequestFullScreen"],u=["","msFullscreenEnabled","msFullscreenElement","MSFullscreenChange","MSFullscreenError","msExitFullscreen","msRequestFullscreen"];document||(document={});var t,c=(t=[l[1],e[1],n[1],u[1]].find(function(e){return document[e]}),[l,e,n,u].find(function(e){return e.find(function(e){return e===t})})||[]);function r(e,n){document[l[0]]=document[c[0]]||!!document[c[2]]||!1,document[l[1]]=document[c[1]]||!1,document[l[2]]=document[c[2]]||null,document.dispatchEvent(new Event(e),n.target)}return document[l[1]]?{}:(document[l[0]]=document[c[0]]||!!document[c[2]]||!1,document[l[1]]=document[c[1]]||!1,document[l[2]]=document[c[2]]||null,document.addEventListener(c[3],r.bind(document,l[3]),!1),document.addEventListener(c[4],r.bind(document,l[4]),!1),document[l[5]]=function(){return document[c[5]]()},void(Element.prototype[l[6]]=function(){return this[c[6]].apply(this,arguments)}))}();
//# sourceMappingURL=fullscreen.polyfill.js.map


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
__webpack_require__(15);__webpack_require__(16);__webpack_require__(17);var _App=__webpack_require__(18);var _App2=_interopRequireDefault(_App);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// @todo Workaround: iOS overlays navigation bars in landscape and the page is not scrollable due
//       to 3D interaction, as a result the bottom part of the page is not visible
window.addEventListener("resize",function(){if(window.innerHeight<document.documentElement.clientHeight){// Make sure the top of the page is displayed and modify it's height to fit within the visible area
window.scrollTo(0,0);document.body.style.maxHeight=window.innerHeight+"px";}else{document.body.style.maxHeight="";}});window.addEventListener("load",function(){var app=new _App2.default();// @todo Hack to expose App to enable it to be called from ModelPicker when a panorama is activated
window.app=app;// @todo Need to implement some form of parameter/server-side routing, this is currently limited to only work on the dev server. Example: 'https://localhost:3000/my-config'
// let pathname   = (window.location.pathname || '').replace(/^[/]+/, '');
// let configName = pathname !== "" ? pathname : "DemoHouse_02";
// Using the GET parameter config. Example https://example.com/configurator/index.html?config=DemoHouse
var configPath=/[?&]{1}config=([^&]+)/.exec(window.location.href);configPath=configPath&&configPath.length>1?configPath[1]:'';var configName=configPath!==""?configPath:"DemoHouse_03";app.loadConfig("config/"+configName+".json").then(function(){/* no-op */},// Fallback to default if not exists
function(){return app.loadConfig("config/default.json");}).then(function(){return app.init();});});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _ModelPicker=__webpack_require__(19);var _ModelPicker2=_interopRequireDefault(_ModelPicker);var _SketchfabWrapper=__webpack_require__(0);var _SketchfabWrapper2=_interopRequireDefault(_SketchfabWrapper);var _Camera=__webpack_require__(2);var _Camera2=_interopRequireDefault(_Camera);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var App=function(){function App(){_classCallCheck(this,App);}_createClass(App,[{key:'getLevelCount',value:function getLevelCount(){return this.config.levels.length;}},{key:'loadConfig',value:function loadConfig(url){var _this=this;return fetch(url).then(function(response){return response.json();}).then(function(config){_this.config=config;// @todo Hack to expose config to ModelPicker and Camera
window.jsonData=_this.config;});}},{key:'init',value:function init(){var _this2=this;this.setProjectTitle(this.config.title);var logoEl=document.getElementById('project-logo');if(this.config.logo&&this.config.logo!==''){logoEl.src="./img/logos/"+this.config.logo;}else{logoEl.parentNode.removeChild(logoEl);}var panoLoadingEl=document.getElementById('panorama-loading');if(this.config.pleasewait&&this.config.pleasewait!==''){panoLoadingEl.src="./img/"+this.config.pleasewait;}else{panoLoadingEl.parentNode.removeChild(panoLoadingEl);}document.getElementById('level-up').addEventListener('touchend',function(e){return _this2.onLevelUp(e);});document.getElementById('level-down').addEventListener('touchend',function(e){return _this2.onLevelDown(e);});document.getElementById('level-up').addEventListener('click',function(e){return _this2.onLevelUp(e);});document.getElementById('level-down').addEventListener('click',function(e){return _this2.onLevelDown(e);});document.getElementById('panorama-close').addEventListener('touchend',function(e){return _this2.onExitPanorama(e);});document.getElementById('panorama-close').addEventListener('click',function(e){return _this2.onExitPanorama(e);});document.getElementById('fullscreen').addEventListener('touchend',function(e){return _this2.toggleFullscreen(e);});document.getElementById('fullscreen').addEventListener('click',function(e){return _this2.toggleFullscreen(e);});if(!document.documentElement.requestFullscreen||!document.fullscreenEnabled){// Device does not support fullscreen
document.getElementById('fullscreen').classList.add('hide');}this.initSketchFab(this.config.sketchfabID);}},{key:'toggleFullscreen',value:function toggleFullscreen(e){e.preventDefault();if(!document.documentElement.requestFullscreen){return;}if(!document.fullscreenElement){document.documentElement.requestFullscreen();}else{if(document.exitFullscreen){document.exitFullscreen();}}}},{key:'initSketchFab',value:function initSketchFab(id){var _this3=this;var client=new Sketchfab('1.3.0',document.getElementById("api-frame"));this.sketchfabwrapper=_SketchfabWrapper2.default;client.init(id,{success:function success(api){// @todo Hack to expose Sketchfab API to ModelPicker and Camera
_SketchfabWrapper2.default.api=api;document.body.classList.remove("loading");api.addEventListener("viewerready",function(){//Initialize the nodemap
_SketchfabWrapper2.default.getSceneGraph();//get the textures list
_SketchfabWrapper2.default.getTextureList();//get the animations list
_SketchfabWrapper2.default.setAnimation(0);//Hide the big sphere we'll project the panos on
_SketchfabWrapper2.default.SetObjectVisibility(_this3.config.panoobject,false,true);// Start at the top level
_this3.setLevel(_this3.getLevelCount()-1);// document.body.classList.remove("loading");
document.body.classList.remove("hide-level-controls");//Set the camera
_SketchfabWrapper2.default.SetView(_this3.config.views['start'].eye,_this3.config.views['start'].lookat,1);//add the event when objects are clicked
_SketchfabWrapper2.default.api.addEventListener('click',_ModelPicker2.default.ClickCallback,{pick:'fast'});_Camera2.default.cameraLoopOrbit();});api.load(function(){api.start();});},error:function onError(e){console.log("Viewer error",e);},autospin:0.0,transparent:0,camera:1,// blending: 0,
ui_stop:0,ui_infos:0,ui_controls:0,ui_watermark:1,scrollwheel:1});}},{key:'setLevel',value:function setLevel(level){this.activeLevel=Math.max(0,Math.min(this.getLevelCount()-1,level));// Update Sketchfab model
for(var i=0;i<=this.getLevelCount()-1;i++){_SketchfabWrapper2.default.SetObjectVisibility(this.config.levels[i]['3dname'],i<=this.activeLevel,true);}// Update UI
var levelNameEl=document.getElementById('level-name');if(levelNameEl){levelNameEl.textContent=this.config.levels[this.activeLevel].name;}var levelUpEl=document.getElementById('level-up');levelUpEl.classList.toggle('disabled',this.activeLevel===this.getLevelCount()-1);var levelDownEl=document.getElementById('level-down');levelDownEl.classList.toggle('disabled',this.activeLevel===0);}},{key:'setProjectTitle',value:function setProjectTitle(title){var titleEl=document.getElementById('project-title');if(titleEl){titleEl.textContent=title;}document.title=title;}},{key:'onLevelUp',value:function onLevelUp(e){e.preventDefault();this.setLevel(this.activeLevel+1);}},{key:'onLevelDown',value:function onLevelDown(e){e.preventDefault();this.setLevel(this.activeLevel-1);}},{key:'onPanoramaLoadStart',value:function onPanoramaLoadStart(){document.body.classList.add('loading-panorama');}},{key:'onPanoramaLoadEnd',value:function onPanoramaLoadEnd(){document.body.classList.remove('loading-panorama');}},{key:'onEnterPanorama',value:function onEnterPanorama(){document.body.classList.add('in-panorama');}},{key:'onExitPanorama',value:function onExitPanorama(e){e.preventDefault();document.body.classList.remove('in-panorama');_ModelPicker2.default.ExitPanoMode();_ModelPicker2.default.EnterOrbitMode();}}]);return App;}();exports.default=App;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Camera=__webpack_require__(2);var _Camera2=_interopRequireDefault(_Camera);var _SketchfabWrapper=__webpack_require__(0);var _SketchfabWrapper2=_interopRequireDefault(_SketchfabWrapper);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ModelPicker={SetPanoMaterialCallback:function SetPanoMaterialCallback(){//get the matrix of the pano sphere
var arrPanoSphere=[];_SketchfabWrapper2.default.getNodeFromGraphByName(_SketchfabWrapper2.default.sceneGraph,app.config.panoobject,'MatrixTransform',arrPanoSphere);if(arrPanoSphere.length>0){//going into pano mode, remove the camera restrictions
clearInterval(_Camera2.default.loopTimeoutIndex);//where's the pano sphere?
var lookat=[arrPanoSphere[0].worldMatrix[12],arrPanoSphere[0].worldMatrix[13],arrPanoSphere[0].worldMatrix[14]];var eye=[lookat[0]+5,lookat[1],lookat[2]];//set up new camera restrictions
_SketchfabWrapper2.default.api.setCameraLookAt(eye,lookat,0,function(){//initialize the new camera behavior
_Camera2.default.inPano=true;_Camera2.default.panoLookat=lookat;_Camera2.default.panoDistance=5;_Camera2.default.cameraLoopPano();_SketchfabWrapper2.default.api.setFov(60,function(err,angle){console.log('err',err);console.log('angle',angle);});window.app.onEnterPanorama();//show the pano sphere
_SketchfabWrapper2.default.SetObjectVisibility(app.config.panoobject,true,true);});}//get rid of the loading message
app.onPanoramaLoadEnd();},enterPanoMode:function enterPanoMode(panoName,clickedId){app.onPanoramaLoadStart();//hide the building
for(var n=0;n<app.config.levels.length;n++){_SketchfabWrapper2.default.SetObjectVisibility(app.config.levels[n]['3dname'],false,true);};//let's see if we already have this pano imported. If so, we can reuse it
if(app.config.panos[panoName].hasOwnProperty("uid")){ModelPicker.setFlatMaterial(app.config.panomaterial,app.config.panos[panoName].uid,ModelPicker.SetPanoMaterialCallback);}else{//apply the pano texture to the panosphere
var url=app.config.panos[panoName]['url'];//add the texture for the pano
_SketchfabWrapper2.default.api.addTexture(url,function(err,textureUid){if(textureUid!==undefined){//cache that id
app.config.panos[panoName].uid=textureUid;ModelPicker.setFlatMaterial(app.config.panomaterial,textureUid,ModelPicker.SetPanoMaterialCallback);};});}},setFlatMaterial:function setFlatMaterial(materialName,textureUid,callback){//find the material of the panosphere so we can update it
_SketchfabWrapper2.default.api.getMaterialList(function(err,materials){for(var n=0;n<materials.length;n++){if(materials[n].name===materialName){//get rid of the diffuse
var materialToUpdate=materials[n];materialToUpdate.channels['Opacity'].factor=1.0;//the pano starts out transparent. Make it opaque here
materialToUpdate.channels['DiffusePBR'].factor=0;materialToUpdate.channels['AlbedoPBR'].factor=0;//set up the emit for a nice flat look
ModelPicker.SetEmitTexture(materialToUpdate,textureUid,0.9);//Apply the change
_SketchfabWrapper2.default.api.setMaterial(materialToUpdate,function(){console.log('Material updated');callback();});}}});},SetEmitTexture:function SetEmitTexture(theMaterial,textureUid,theFactor){var myTexture=_SketchfabWrapper2.default.MakeTexture(textureUid);theMaterial.channels['EmitColor'].enable=true;theMaterial.channels['EmitColor'].texture=myTexture;theMaterial.channels['EmitColor'].factor=theFactor;delete theMaterial.channels['EmitColor'].color;//delete the color value, otherwise the material is invalid
},EnterOrbitMode:function EnterOrbitMode(){var theView=app.config.views['start'];_SketchfabWrapper2.default.SetView(theView.eye,theView.lookat,0);_SketchfabWrapper2.default.api.setFov(45,function(){});_Camera2.default.cameraLoopOrbit();// bring back the buildings
app.setLevel(app.activeLevel);},ExitPanoMode:function ExitPanoMode(){//change the camera loop
_Camera2.default.inPano=false;clearInterval(_Camera2.default.loopTimeoutIndex);//hide the pano sphere
_SketchfabWrapper2.default.SetObjectVisibility(app.config.panoobject,false,true);},ClickCallback:function ClickCallback(clickEvent){if(_Camera2.default.inPano===false){var theName=_SketchfabWrapper2.default.getNodeNameById(clickEvent.instanceID);if(app.config.panos.hasOwnProperty(theName)){ModelPicker.enterPanoMode(theName,clickEvent.instanceID);}};}};exports.default=ModelPicker;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.59e961e4.js